<template>
  <div>
    <div class="title is-4">{{ title }}</div>
    <div class="subtitle is-6">{{ subtitle }}</div>

    <div class="tile is-ancestor m-b-md">
      <div class="tile is-parent" v-for="dashboard in dashboards" :key="dashboard.id">
        <router-link
          :to="{ name: 'dashboard', params: { id: dashboard.id } }"
          class="tile is-child card"
          active-class="has-background-primary has-text-white"
        >
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <span class="icon is-medium">
                  <i class="mdi mdi-24px mdi-chart-bar-stacked"></i>
                </span>
              </div>
              <div class="media-content">
                <div class="is-size-6 has-text-weight-semibold">
                  {{ dashboard.name }}
                </div>
                <div class="is-size-7 m-t-xs">{{ dashboard.year }}</div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- <aside class="menu">
      <span class="title is-5">{{ title }}</span>
      <p class="menu-label">{{ subtitle }}</p>
      <ul class="menu-list">
        <li v-for="dashboard in dashboards" :key="dashboard.id">
          <router-link
            active-class="is-active"
            :to="{ name: 'dashboard', params: { id: dashboard.id } }"
            >{{ dashboard.name }}</router-link
          >
        </li>
      </ul>
    </aside> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({ dashboards: state => state.dashboard.dashboards })
  },
  data() {
    return {
      title: 'Инфопанели',
      subtitle: process.env.VUE_APP_INDICATORS_NAME
    };
  }
};
</script>

<style lang="scss" scoped>
// .media-content {
//   line-height: 1.2;
// }
</style>
